// src/utils/abiel.ts
import { callFunction } from '@/integrations/supabase/functions';
import { abielPrayerPrompt } from '@/utils/abiel/abielPrayerPrompt';
import type { BibleVerseContext } from '@/types/prayerChoice';

export type GeneratePrayerParams = {
  message: string;
  tags: string[];
  includeVerse: boolean;
  subject?: string;
  bilingual?: boolean;
  esvVerse?: string;
  bibleVerseContext?: BibleVerseContext;
};

export type GeneratePrayerResult = {
  prayer: string;
  error?: string;
};

export async function generatePrayer(params: GeneratePrayerParams): Promise<GeneratePrayerResult> {
  // Build the exact prompt with your existing helper (no fabrication rules enforced here)
  const prompt = abielPrayerPrompt(
    params.message,
    params.tags ?? [],
    params.subject,
    !!params.bilingual,
    [], // allowedReferences
    params.esvVerse,
    params.bibleVerseContext
  );

  // Call the Edge Function in "prayer" mode with the prebuilt prompt
  const { data, error, status } = await callFunction<any>('abiel-prayer', {
    body: { mode: 'prayer', prompt }
  });

  if (error || status >= 400) {
    return { prayer: '', error: error?.message ?? `HTTP ${status}` };
  }

  // Accept either shape (message or prayer) to be tolerant of server variants
  const prayer: string = data?.prayer ?? data?.message ?? '';
  if (!prayer) return { prayer: '', error: 'Empty prayer from server' };

  return { prayer };
}

// Back-compat alias if anything still imports this name
export const generatePrayerViaAbiel = generatePrayer;